import { Component, OnDestroy, Inject, OnInit, ViewChild } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { AolService } from '../../services/aol';
import {
  takeUntil,
  delay,
  map,
  tap,
  debounceTime,
  distinctUntilChanged,
} from 'rxjs/operators';
import { SharedValidators } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
import {
  OptionService,
  OptionTypeService,
} from 'src/modules/features/setting/services';
interface ICompanyInfoModalContext {
  title?: string;
  sharesAmount: {
    totalUnallocatedShare: number;
    totalShareCapital: number;
    totalShareAllocated: number;
  };
}
@Component({
  selector: 'app-new-edit-shares.component-modal-modal',
  templateUrl: './edit-shares-component.html',
  styleUrls: ['./edit-shares-component.scss'],
})
export class EditSharesModalComponent implements OnInit, OnDestroy {
  @ViewChild('captchaRef') refCapt;
  private unsubscribe$: Subject<void> = new Subject<void>();
  companyDetail: any;
  success: any;
  public loginPending: boolean;
  public detailForm: FormGroup;
  public pending: boolean;
  public formSubmitAttempt = false;
  public bppDetail: any;
  public error: any;
  public countries: any;
  public states: any;
  public mode = 'year';
  public max = new Date();

  public companyEmailLoading = false;
  public usernameLoading = false;
  public emailLoading = false;

  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: '',
      },
      {
        field: 'optionName',
        op: 'cn',
        data: '',
      },
    ],
  };
  filter: AppFilter = new AppFilter();
  optionType;
  lookupTemplates;
  extraData;
  DataEdit;
  organizationId;
  shareAmount;
  nccId;
  shareUnallocatedPercentage;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICompanyInfoModalContext, void, void>,
    private http: HttpClient,
    private organizationSvc: OrganizationService,
    private optionTypeSvc: OptionTypeService,
    private AolService: AolService,
    private optionSvc: OptionService
  ) {
    this.nccId = JSON.parse(
      window.localStorage.getItem('organization')
    ).jpaContractor.nccId;
    this.shareAmount = this.modal.context.sharesAmount;
    this.organizationId = window.localStorage.getItem('organizationId');
    this.detailForm = this.fb.group({
      percentageShareType: [true],
      totalUnallocatedShare: [
        this.shareAmount.totalUnallocatedShare,
        [Validators.required],
      ],
      totalShareCapital: [
        this.shareAmount.totalShareCapital,
        [Validators.required],
      ],
    });

    // Subscribe to value changes

    this.detailForm
      .get('totalUnallocatedShare')
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.updateShareAmounts());
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.optionSvc.getPublicOption({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.lookupTemplates = res.rows;
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  ngOnDestroy() {}
  ngOnInit() {}
  submit() {
    this.pending = true;
    let payload = {
      percentageShareType: true,
      totalShareCapital: Number(this.detailForm.value.totalShareCapital),
      totalUnallocatedShare: Number(
        this.detailForm.value.totalUnallocatedShare
      ),
    };

    this.AolService.updateShareDetails({
      nccId: this.nccId,
      body: payload,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'Total Share Capital Updated';
        setTimeout(() => {
          this.modal.approve(this.detailForm.value.totalShareCapital);
        }, 2000);
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  private updateShareAmounts() {
    const totalUnallocatedShare =
      Number(this.detailForm.get('totalUnallocatedShare').value) || 0;

    const totalShareCapital =
      Number(this.detailForm.get('totalShareCapital').value) || 0;

    // Calculate unallocated percentage
    if (totalUnallocatedShare > 0) {
      this.shareUnallocatedPercentage = (
        (totalUnallocatedShare / totalShareCapital) *
        100
      ).toFixed(2);

      if (totalUnallocatedShare > totalShareCapital) {
        this.error =
          'Total Unallocated Share cannot be greater than Total Share Capital';
        this.detailForm.get('totalUnallocatedShare').setErrors({
          invalid: true,
        });
      }
    } else {
      this.shareUnallocatedPercentage = 0;
    }
  }
}
export class EditSharesModal extends ComponentModalConfig<
  ICompanyInfoModalContext,
  void,
  void
> {
  constructor(
    title: string,
    sharesAmount: {
      totalUnallocatedShare: number;
      totalShareCapital: number;
      totalShareAllocated: number;
    },
    size: ModalSize = ModalSize.Mini
  ) {
    super(EditSharesModalComponent, { title, sharesAmount });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
